import gql from 'graphql-tag'

export const customNotificationClassDelete = gql`
  mutation customNotificationClassDelete($notificationClassId: ID!) {
    customNotificationClassDelete(input: { notificationClassId: $notificationClassId }) {
      success
    }
  }
`
